<template>
    <div>
        <b-form-file class="input" ref="form-file" :name="name" title="" :placeholder="placeholder" v-model="newValue" single :accept="accept" @focus="$emit('focus')" @blur="$emit('blur')"/>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    components: {},
    name: 'upload',
    mixins: [
        Default,
    ],
    props: ['name', 'placeholder', 'value', 'accept'],
    data() {
        return {
            newValue: ''
        };
    },
    created() {
        this.newValue = this.value;
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    },
    methods: {
        open: function() {
            this.$refs['form-file'].$refs.input.click(); // Manually activates the file upload window
        }
    }
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/styles/customInput/input";
    .input {
        z-index: 0;
        overflow: hidden;
    }
</style>
